import { v4 as uuid } from "uuid";
import {Model} from "./base/Model";
import {Collection} from "./base/Collection";

    export class WindowModel extends Model  {
        public
      index: number;
      style: object;
      x: number = 0;
      y: number = 0;
      width: number = 400;
      height: number = 200;
      element: any;
      childWindow: string = "";
      _parent:string = "";
      data:object = {};
      footer = null;
      step:number = 1;
//      title: string = null;
//      onCloseHandler:any;
      public window: string;
      is_open: number = 1;
      zindex: 800;
      childElements: any[] = [];
        constructor(data = null) {
            super();
            if(data) {
                this.createModel(data);
            }
            
        }

        public setData(name, val) {
            if(!val) {
                delete this.data[name];
            } else {
                if(!this.data) {
                    this.data = {};
                }
                this.data[name] = val;
            }
        }
        
          public setPosition(val) {
            if(!val) {
                delete this.data['pos'];
            } else {
                if(!this.data) {
                    this.data = {};
                }
                this.data['pos'] = val;
            }
        }
        
        public setFooter(footerVal) {
            this.footer = footerVal;
        }
        
        get parent() {
            return this._parent;
        }
        
        set parent(val:any) {
            if(val instanceof WindowModel) {
                this._parent = this._parent + val.uid;
            } else if(val != "") {
                if(this._parent != "") {
                    this._parent = this._parent + ".";
                }
                this._parent = this._parent + val;
            }
        }      
        
        getParentId() {
            let retVal = this._parent;
            if(retVal != "") retVal = retVal + ".";
            return retVal+ this.uid;
        }

    }